/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const stripeFeatureSchema = z.enum([
	'jobilla-meet',
	'fully-serviced',
	'addon-ats-integration',
	'addon-custom-templates',
	'addon-custom-invoicing-config',
	'addon-whatsapp',
])

export type StripeFeatureSchema = z.infer<typeof stripeFeatureSchema>
